module.exports = __webpack_public_path__ + "static/blog43-e3e67d2159a5b3941c3991efcfacc2fd.png";